import { ShoppingCartOrder } from "../reducers/shoppingCartOrder";
import { ORDER_COMPLETE } from "../constants/routes";

import { Coupon } from "../reducers/models/users";
import { CART_STATES } from "../components/Orders/constants";

export const hasShippingAddressSet = (shoppingCart: ShoppingCartOrder) => {
  return shoppingCart.shipping_address !== null;
};

export const hasShippingRateSet = (shoppingCart: ShoppingCartOrder) => {
  return shoppingCart.shipping_rate !== null;
};

const hasShippingOptionsSet = (shoppingCart: ShoppingCartOrder) => {
  return (
    hasShippingAddressSet(shoppingCart) && hasShippingRateSet(shoppingCart)
  );
};

export const hasPickupOptionsSet = (shoppingCart: ShoppingCartOrder) => {
  return shoppingCart.pickup_info !== null;
};

export const doesHaveDeliverOptionsSet = (shoppingCart: ShoppingCartOrder) => {
  return (
    hasShippingOptionsSet(shoppingCart) || hasPickupOptionsSet(shoppingCart)
  );
};

export const isOrderAccepted = (shoppingCartOrder: ShoppingCartOrder) => {
  return !CART_STATES.has(shoppingCartOrder.state);
};

export const buildOrderCompleteUrl = (shoppingCart: ShoppingCartOrder) => {
  return ORDER_COMPLETE.replace(
    "[orderId]",
    shoppingCart.next_order_id as string,
  );
};

export const isCouponAppliedToCart = (
  coupon: Coupon,
  shoppingCart: ShoppingCartOrder,
): boolean => {
  return !!shoppingCart.coupons_applied.find(
    (appliedCoupon) => appliedCoupon.id == coupon.id,
  );
};
